import { useEffect } from "react";

const SITE = "ONWARD MEDIA";

export default function useSeo(title, description) {
  useEffect(() => {
    document.title = title ? `${title} — ${SITE}` : `${SITE} — Political Campaign & Creative Agency, Indore`;
    const set = (sel, attr, val) => {
      let el = document.head.querySelector(sel);
      if (!el) return;
      el.setAttribute(attr, val);
    };
    if (description) {
      set('meta[name="description"]', "content", description);
      set('meta[property="og:description"]', "content", description);
    }
    set('meta[property="og:title"]', "content", document.title);
    set('meta[name="twitter:title"]', "content", document.title);
  }, [title, description]);
}
